<template lang="pug">
  .card.relatedArticle_modal_card
    .title.is-3 関連記事の設定
    .relatedArticle_modal_content
      // 記事一覧
      template(v-if="isReleasedArticleShown")
        .relatedArticle_modal_released
          .relatedArticle_modal_released_header
            .relatedArticle_modal_released_heading 記事一覧
            .relatedArticle_modal_released_note ＊最大3件選択できます
            .relatedArticle_modal_released_search
              b-field
                b-select(
                  v-model="searchForm.category"
                  placeholder="カテゴリで絞り込む"
                  rounded
                  size="is-medium"
                  @input="onFormChange")
                  option(:value="null") 選択しない
                  option(v-for="(category, index) in categoryList" :value="category.value") {{ category.screen_name }}
              b-field
                b-input(
                  v-model="searchForm.key"
                  placeholder="キーワードで検索"
                  type="search"
                  icon="search"
                  rounded
                  size="is-medium"
                  @input="onFormChange")
          #js_relatedArticle_content_released.relatedArticle_content._released
            b-loading(v-model="infiniteScroll.isLoading" :is-full-page="infiniteScroll.isFullPage")
            ul#js_relatedArticle_list.relatedArticle_list._released(
              v-if="releasedArticleList.length > 0")
              li.relatedArticle_list_item(v-for="(releasedArticle, index) in releasedArticleList")
                a.relatedArticle_list_card(
                  @click.prevent="addRelatedArticle(releasedArticle, $event)"
                  :class="{ 'is_disabled' : isRelatedArticleFilled, 'is_selected' : newRelatedArticleList.find(article  => article.id === releasedArticle.id) }")
                  .relatedArticle_list_thumb
                    .relatedArticle_list_thumb_image(
                      v-if="releasedArticle.thumbnail == null"
                      :style="'background-image: url('+ defaultThumbnail +')'")
                    .relatedArticle_list_thumb_image(
                      v-else
                      :style="'background-image: url('+ releasedArticle.thumbnail +')'")
                  .relatedArticle_list_head
                    p.relatedArticle_list_title {{ releasedArticle.title }}
            p.relatedArticle_list_empty(v-show="releasedArticleList.length === 0 && !infiniteScroll.isLoading") 該当する記事はありません
        // sp & tablet device only
        b-button.relatedArticle_modal_change._spDisp._text_decoration_none(
          type="is-text"
          size="is-large"
          outlined
          icon-left="arrow-circle-left"
          @click="switchArticleContent()") 選択中の記事を見る
      // 関連記事
      template(v-if="isRelatedArticleShown")
        .relatedArticle_modal_related
          .relatedArticle_modal_related_header
            .relatedArticle_modal_related_heading 関連記事
            .relatedArticle_modal_related_note ＊ドラッグ&ドロップで並び替え
          #js_relatedArticle_content_related.relatedArticle_content._related
            ul.relatedArticle_list._related(v-if="newRelatedArticleList.length > 0" v-sortable="sortableOptions")
              li.relatedArticle_list_item(v-for="(relatedArticle, index) in newRelatedArticleList" :key="relatedArticle.id")
                .relatedArticle_list_card
                  b-icon.is-opacity.mr-5(icon="draggabledots" size="is-small")
                  .relatedArticle_list_thumb
                    .relatedArticle_list_thumb_image(
                      v-if="relatedArticle.thumbnail == null"
                      :style="'background-image: url('+ defaultThumbnail +')'")
                    .relatedArticle_list_thumb_image(
                      v-else
                      :style="'background-image: url('+ relatedArticle.thumbnail +')'")
                  .relatedArticle_list_head
                    p.relatedArticle_list_title {{ relatedArticle.title }}
                    p.relatedArticle_list_note(v-if="relatedArticle.release_flag === false")
                      b-icon.mb-2.mr-3(icon="exclamation-circle" size="is-small")
                      | この記事は「下書き」状態になっています
                  button.ui-icon-button(@click.stop="removeRelatedArticle(relatedArticle)")
                    b-icon.is-opacity(icon="minus-circle")
            p.relatedArticle_list_empty(v-else) 関連記事は選択されていません
        // sp & tablet device only
        b-button.relatedArticle_modal_change._spDisp._text_decoration_none(
          v-if="newRelatedArticleList.length < 3"
          type="is-text"
          size="is-large"
          outlined
          icon-left="plus-circle"
          @click="switchArticleContent()") 記事を選択する
        b-button.relatedArticle_modal_change._spDisp._text_decoration_none(
          v-else
          type="is-text"
          size="is-large"
          outlined
          icon-right="arrow-circle-right"
          @click="switchArticleContent()") 記事一覧を見る
    .relatedArticle_modal_footer
      // sp & tablet device only
      p.relatedArticle_modal_number
        span._current {{ newRelatedArticleList.length }}
        | /3件選択中
      // all device
      b-button.relatedArticle_modal_submit(
        type="is-info"
        size="is-medium"
        @click="setRelatedArticle()") 設定に反映する
</template>

<script>
import Sortable from 'sortablejs/modular/sortable.core.esm.js'

const createSortable = (el, options, vnode) => {
  return Sortable.create(el, {
    ...options,
    onEnd: function (evt) {
      const data = vnode.context.$data.newRelatedArticleList
      const item = data[evt.oldIndex]
      if (evt.newIndex > evt.oldIndex) {
        for (let i = evt.oldIndex; i < evt.newIndex; i++) {
          data[i] = data[i + 1]
        }
      } else {
        for (let i = evt.oldIndex; i > evt.newIndex; i--) {
          data[i] = data[i - 1]
        }
      }
      data[evt.newIndex] = item
    }
  })
}

const sortable = {
  name: 'sortable',
  bind(el, binding, vnode) {
    el._sortable = createSortable(el, binding.value, vnode)
  },
  update(el, binding, vnode) {
    el._sortable.destroy()
    el._sortable = createSortable(el, binding.value, vnode)
  },
  unbind(el) {
    el._sortable.destroy()
  }
}

export default {
  name: 'RelatedArticleModal',
  directives: { sortable },
  data: function(){
    return {
      categoryList: [],
      releasedArticleList: [],
      newRelatedArticleList: [],
      isRelatedArticleFilled: false,
      defaultThumbnail: process.env.VUE_APP_PUBLIC_PATH + 'img/thumb_default.jpg',

      /* 記事一覧・関連記事 切り替え */
      mql: null,
      isRelatedArticleShown: true,
      isReleasedArticleShown: true,

      /* 絞り込みフォーム */
      searchForm: {
        category: null,
        key: "",
      },

      /* 記事一覧 無限スクロール */
      infiniteScroll: {
        limit:15,
        offset: 0,
        keyword: '',
        isLastPage: false, // 無限スクロール終了時にtrue
        isLoading: false,
        isFullPage: false
      },
      /* SortableJS */

      sortableOptions: {
        chosenClass: 'is_sortable',
        draggable: 'li'
      }
    }
  },
  props: [
    'isModalActive',
    'oldRelatedArticleList',
    'article'
  ],
  created() {
    this.getReleasedArticleList()
    this.getCategoryList()

    this.newRelatedArticleList = this.oldRelatedArticleList.slice()
  },
  mounted() {
    this.mql = window.matchMedia( '(max-width: 960px)' )
    this.mql.addListener(this.setArticleContent)
    this.setArticleContent()

    window.addEventListener('resize', this.adaptScrollContentHeight)
    this.adaptScrollContentHeight()

    this.setInfiniteScroll()
  },
  destroyed(){
    window.removeEventListener('resize', this.adaptScrollContentHeight)
  },
  watch: {
    'newRelatedArticleList'(list) {
      this.isRelatedArticleFilled = (list.length >= 3) ? true : false

      this.$emit('passNewRelatedArticleList', this.newRelatedArticleList)
    }
  },
  methods: {
    onFormChange() {
      this.getReleasedArticleList('search')
    },
    closeModal() {
      this.$emit('closeModal')
    },
    setArticleContent() {
      if(this.mql.matches) {
        this.isReleasedArticleShown = false
      } else {
        this.isRelatedArticleShown = true
        this.isReleasedArticleShown = true
      }
    },
    switchArticleContent() {
      this.isRelatedArticleShown = !this.isRelatedArticleShown
      this.isReleasedArticleShown = !this.isReleasedArticleShown
      if(this.isReleasedArticleShown) this.setInfiniteScroll()

      this.adaptScrollContentHeight()
    },
    adaptScrollContentHeight() {
      this.$nextTick(function() {
        const relatedArticleContent = document.getElementById('js_relatedArticle_content_related')
        const releasedArticleContent = document.getElementById('js_relatedArticle_content_released')
        const windowHeight = window.innerHeight

        if( releasedArticleContent ) {
          if( this.mql.matches ) {
            releasedArticleContent.style.cssText = 'height: calc(' + windowHeight + 'px - 360px);' // 画面の高さ - 上下コンテンツ分の高さ
          } else {
            releasedArticleContent.style.cssText = 'height: 400px;'
          }
        }

        if( relatedArticleContent ) {
          if( this.mql.matches ) {
            relatedArticleContent.style.cssText = 'height: auto; max-height: calc(' + windowHeight + 'px - 320px);' // 画面の高さ - 上下コンテンツ分の高さ
          } else {
            relatedArticleContent.style.cssText = 'height: 400px; max-height: none;' // 画面の高さ - 上下コンテンツ分の高さ
          }
        }
      })
    },
    addRelatedArticle(article, e) {
      if(this.isRelatedArticleFilled) {
        e.preventDefault()
      } else {
        this.newRelatedArticleList.push(article)
      }
    },
    removeRelatedArticle(article) {
      const articleIndex = this.newRelatedArticleList.findIndex(relatedArticle => relatedArticle.id === article.id)
      this.newRelatedArticleList.splice( articleIndex, 1 )
    },
    setRelatedArticle() {
      this.$emit('setRelatedArticle')
      this.closeModal()
    },
    setInfiniteScroll() {
      this.$nextTick(function() {
        const releasedArticleContent = document.getElementById('js_relatedArticle_content_released')
        if( releasedArticleContent ) {
          releasedArticleContent.addEventListener( 'scroll', this.getArticleListScroll )
        }
      })
    },
    getArticleListScroll() {
      const elm = document.getElementById('js_relatedArticle_content_released')
      const list = document.getElementById('js_relatedArticle_list')

      const HeightAdjustment = 80
      if( elm && list && !this.infiniteScroll.isLastPage ){
        // 最下部の画像が画面に入ったら次のページを読み込む
        if( list.getBoundingClientRect().bottom < elm.getBoundingClientRect().bottom + HeightAdjustment ){
          if(this.infiniteScroll.isLoading === false){
            this.getReleasedArticleList()
          }
        }
      }
    },
    async getReleasedArticleList(type) {
      try {
        this.infiniteScroll.isLoading = true

        if( type === 'search' ) { // カテゴリ・キーワード検索
          this.infiniteScroll.offset = 0
          this.infiniteScroll.isLastPage = false
        }

        const data_obj = {
          contents: this.searchForm.category,
          keyword: this.searchForm.key,
          limit: this.infiniteScroll.limit,
          offset: this.infiniteScroll.offset
        }

        const res = await this.$axios.get(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.RELEASED_ARTICLES,
          { params: data_obj }
        )

        const r = res.data

        if (r.status == 1) {
          const data = r.data
          const dataExcludedOwn = data.filter( article => article.id !== this.article.id )

          this.infiniteScroll.offset += this.infiniteScroll.limit

          if( type === 'search' ) {
            this.releasedArticleList = dataExcludedOwn
          } else {
            this.releasedArticleList = this.releasedArticleList.concat(dataExcludedOwn)
          }

          this.$nextTick(function() {
            const totalCount = ( this.article.id && this.article.release_flag ) ? ( r.meta.total_count - 1 ) : r.meta.total_count

            // 記事一覧の総数＝記事の総数となった時点で、無限スクロールストップ
            this.infiniteScroll.isLastPage = ( this.releasedArticleList.length === totalCount ) ? true : false

            if( type === 'search' ) {
              const releasedArticleContent = document.getElementById('js_relatedArticle_content_released')
              releasedArticleContent.scrollTo(0, 0)
            }
          })
        } else {
          this.$common.createErrorMessage(
            r.errors,
            "記事一覧の取得に失敗しました。時間を空けて、もう一度お試しください。"
          )
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.infiniteScroll.isLoading = false
      }
    },
    async getCategoryList() {
      const data_obj = {
        sort: 2,
      };
      try {
        const res = await this.$axios.get(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.CATEGORIES,
          { params: data_obj }
        )
        const r = res.data
        if (r.status == 1) {
          this.categoryList = r.data
        } else {
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(
              r.errors,
              "カテゴリの取得に失敗しました。時間を空けて、もう一度お試しください。"
            )
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    }
  }
}
</script>